import { render } from "./ThresholdCheckboxList.vue?vue&type=template&id=7a08b006&scoped=true"
import script from "./ThresholdCheckboxList.vue?vue&type=script&lang=js"
export * from "./ThresholdCheckboxList.vue?vue&type=script&lang=js"

import "./ThresholdCheckboxList.vue?vue&type=style&index=0&id=7a08b006&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a08b006"]])

export default __exports__